<template>
  <div
    class="fixed bg-white flex flex-col z-50
    rounded-14px px-5 w-350px md:w-600px md:h-773px center-screen Parent"
  >
    <div>
      <div
        v-on:click="modalClose"
        id="cross-modal"
        class="float-right h-21px w-21px md:h-12 md:w-12 mt-4 flex flex-col justify-center relative"
      ></div>
    </div>
    <div
      class="text-qwray font-bold md:text-3xl md:px-10 bg-partial mr-6 font-Foco yell Title"
    >
      <span class="popup-first-line">{{ $t('pilot_popup.first_line') }}</span>
      {{ $t('pilot_popup.following_lines') }}
    </div>

    <div
      class="flex flex-row items-center flex-auto flex-grow md:justify-between"
    >
      <div class="w-120px md:w-150px">
        <img src="~@/assets/station-popup.png" />
      </div>
      <div
        class="flex flex-col ml-8  md:ml-8 md:mr-10 self-start TextContainer"
      >
        <div class="text-14px md:text-20px text-qwray md:px-10 mb-2">
          {{ $t('pilot_popup.txt') }}
        </div>
        <div v-if="!matchEntities(['UK'])">
          <a
            v-for="(location, key) in locations"
            :key="key"
            :href="location.url"
          >
            <div class="flex flex-row mt-1">
              <img class="md:h-10" src="~@/assets/yellow-mark.svg" />
              <div class="text-qwraylight text-14px ml-2 md:text-20px">
                {{ $t(location.text) }}
              </div>
            </div>
          </a>
        </div>
        <div v-else>
          <a
            v-for="(location, key) in locations"
            :key="key"
            :href="location.url"
          >
            <div class="locationText">
              <img class="md:h-10" src="~@/assets/yellow-mark.svg" />
              <div class="text-qwraylight text-14px ml-2 md:text-20px">
                {{ $t(location.text) }}
                <div v-if="location.live.toLowerCase() === 'live'" class="Live">
                  LIVE
                </div>
                <span v-else>{{ location.liveDate }}</span>
              </div>
            </div>
          </a>
        </div>
        <div class="flex flex-col text-qwraysuperlight mt-2 BottomText">
          <div class="flex flex-row items-center">
            <div class="w-20px"><img src="~@/assets/mail-ic-popup.svg" /></div>
            <div class="ml-1">{{ $t('contact.support_mail') }}</div>
          </div>
          <div class="flex flex-row items-center">
            <div class="w-20px"><img src="~@/assets/phone-ic-popup.svg" /></div>
            <div class="ml-1">{{ $t('contact.support_phone') }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import locations from '@/data/locations.json';
import matchEntities from '../../../shared/entityHelpers';

export default {
  name: 'PopupStations',
  data() {
    return { locations };
  },
  methods: {
    modalClose() {
      this.$emit('modalClose');
    },
    matchEntities,
  },
};
</script>

<style scoped>
.Parent {
  --title-f-size: 26px;
  --text-f-size: 12px;
  --parent-min-height: 500px;
  min-height: var(--parent-min-height);
  padding-bottom: 0.5em;
}
.Title {
  font-size: var(--title-f-size);
}
.TextContainer {
  font-size: var(--text-f-size);
  align-self: center;
}
.BottomText {
  font-size: var(--text-f-size);
}

.pop {
  height: 550px;
  top: 10%;
}
#cross-modal::before,
#cross-modal::after {
  position: absolute;
  content: '';
  width: 100%;
  height: 3px;
  @apply bg-qwraybright;
}

#cross-modal::before {
  transform: rotate(45deg);
}
#cross-modal::after {
  transform: rotate(-45deg);
}

.popup-first-line {
  background-color: #ffdf22;
  padding: 5px;
  border-color: #ffdf22;
}

.center-screen {
  position: fixed;
  top: 50%;
  left: 50%;
  /* bring your own prefixes */
  transform: translate(-50%, -50%);
}

@media (min-width: 360px) {
  .Parent {
    --title-f-size: 30px;
    --text-f-size: 14px;
    --parent-min-height: 560px;
  }
}
@media (min-width: 768px) {
  .Parent {
    --text-f-size: 20px;
  }
}
.locationText {
  display: grid;
  grid-template-columns: auto auto auto;
}
.Live {
  background: red;
  color: white;
  padding: 0 1em;
  font-size: 11px;
  height: 20px;
  border-radius: 4px;
  display: grid;
  place-items: center;
  align-self: center;
  padding-left: 1em;
  width: min-content;
}
</style>
